import { PropertyTypeEnum } from '~/core/entities/CRMEnums';

export const REGION_PROPERTY_TYPE_ORDER: readonly PropertyTypeEnum[] = [
	PropertyTypeEnum.APARTMENT,
	PropertyTypeEnum.HOUSE,
	PropertyTypeEnum.PENTHOUSE,
	PropertyTypeEnum.CONDO_HOUSE,
	PropertyTypeEnum.VILLAGE_HOUSE,
	PropertyTypeEnum.DUPLEX,
	PropertyTypeEnum.GARDEN,
	PropertyTypeEnum.TRIPLEX,
	PropertyTypeEnum.FLAT,
	PropertyTypeEnum.LOFT,
	PropertyTypeEnum.STUDIO,
	PropertyTypeEnum.LAND,
	PropertyTypeEnum.CONDO_LAND
];
